import * as React from 'react';
import { useEffect } from 'react';
import { useInstallApp } from '@wix/app-installer';
import { getPropsFromSearchParams } from '../../utils/getPropsFromSearchParams';
import { usePostInstallationUrl } from '../../utils/usePostInstallationUrl';

// todo add tests
export const PageWithScriptInstaller = () => {
  const installApp = useInstallApp({
    platform: 'INSTALLER_STANDALONE',
  });
  const {
    appId,
    version,
    avoidPostInstallation,
    tenantType,
    tenantId,
    versionOverrideId,
    title,
    subtitle,
    ctaText,
    openInIframe,
    hideCloseButton,
  } = getPropsFromSearchParams();

  const { redirectToPostInstallationUrlIfRequired, hasPostInstallationUrl } =
    usePostInstallationUrl();

  useEffect(() => {
    installApp({
      appId,
      tenantType,
      tenantId,
      version,
      avoidPostInstallation: avoidPostInstallation || hasPostInstallationUrl,
      versionOverrideId,
      devModeSelectorTitle: title,
      devModeSelectorSubtitle: subtitle,
      devModeSelectorCtaText: ctaText,
      openInIframe,
      preventClosingDevSiteSelector: hideCloseButton,
    }).then((response) => {
      redirectToPostInstallationUrlIfRequired(response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
